import gql from "graphql-tag";

const userQueries = {


    findUsers: gql`
        query FindUsers($name: String) {
          findUsers(count: 10, name: $name) {
            data {
              id
              name
            }
          }
        }
    `,

};

export default userQueries;
